import React, { useEffect, useState } from 'react';
import {
  Button, message, Spin, Pagination, Table,
} from 'antd';
import { useNavigate } from 'react-router-dom';
import './CompanyGroupList.scss';
import { get } from '../../dataSource/data_repository';

export default function CompanyGroupList() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [listData, setListData] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState({
    current: 1,
    currentTotal: 0,
    pageSize: 1,
    total: 0,
  });

  async function fetchData(page) {
    get({ url: `/companyGroup?page=${page - 1}` }).then((response) => {
      setLoading(false);
      if (!response.error) {
        const data = response.companyGroups;
        setListData(data);
        // setPaginationInfo({
        //   current: page,
        //   currentTotal: data.length,
        //   pageSize: 5,
        //   total: dataSource.length,
        // });
      } else {
        message.error('Erro ao carregar os dados');
      }
      setLoading(false);
    }).catch((err) => {
      console.log('Erro ', err);
      message.error('Ocorreu um erro na requisição. Por favor, tente novamente mais tarde');
      setLoading(false);
    });
  }

  const columns = [
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
    },
  ];

  useEffect(() => {
    fetchData(1);
  }, []);

  return (
    <div className="CompanyGroupList">
      <Spin
        tip="Carregando"
        spinning={loading}
      >
        <Button
          className="btn-primary btn-add-new"
          onClick={() => navigate('/grupos/cadastrar')}
        >
          Cadastrar novo
        </Button>
        <Table dataSource={listData} columns={columns} pagination={false} rowKey="id" />
        {/* <Pagination */}
        {/*  className="pagination-container" */}
        {/*  onChange={(page) => { fetchData(page); }} */}
        {/*  defaultCurrent={1} */}
        {/*  current={paginationInfo.current} */}
        {/*  pageSize={paginationInfo.pageSize} */}
        {/*  total={paginationInfo.total} */}
        {/* /> */}
      </Spin>
    </div>
  );
}
